import { render, staticRenderFns } from "./AddCourseView.vue?vue&type=template&id=4257e81b&"
import script from "./AddCourseView.vue?vue&type=script&lang=ts&"
export * from "./AddCourseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports